import type { ProjectFilters, ReportFilters, ReportSearchFilters } from "./types";

/**
 * Query keys. Each key starts with its domain so that a mutation can invalidate a whole domain
 * with its prefix (`["projects"]` refetches every filtered list).
 */
export const qk = {
  me: ["me"] as const,
  myAssignments: ["assignments", "me"] as const,

  projects: ["projects"] as const,
  projectList: (filters: ProjectFilters) => ["projects", "list", filters] as const,
  project: (slug: string) => ["project", slug] as const,
  projectAny: ["project"] as const,
  projectHistory: (slug: string) => ["project", slug, "history"] as const,
  technologies: (q: string) => ["technologies", q] as const,

  requests: ["requests"] as const,
  requestList: (filters: Record<string, unknown>) => ["requests", "list", filters] as const,
  requestPreview: (id: number, input: Record<string, unknown>) => ["requests", "preview", id, input] as const,

  reports: ["reports"] as const,
  weekContext: (week: string) => ["reports", "me", week] as const,
  reportList: (filters: ReportFilters) => ["reports", "list", filters] as const,
  reportSearch: (filters: ReportSearchFilters) => ["reports", "search", filters] as const,

  people: (q: string, assignable: boolean) => ["people", q, assignable] as const,
  followUp: (id: number, year: number) => ["people", "follow-up", id, year] as const,
  coachees: ["me", "coachees"] as const,

  admin: ["admin"] as const,
  adminPeople: (filters: Record<string, unknown>) => ["admin", "people", filters] as const,
  facets: ["admin", "facets"] as const,
  unlinked: ["admin", "unlinked"] as const,
  rule: ["admin", "rule"] as const,
  settings: ["admin", "settings"] as const,
  dar: ["admin", "dar"] as const,
  compliance: (week: string) => ["admin", "compliance", week] as const,
  sync: ["admin", "sync"] as const,
  staffing: ["admin", "staffing"] as const,
  unassigned: ["admin", "unassigned"] as const,
  dashboard: ["admin", "dashboard"] as const,
  resources: ["admin", "resources"] as const,

  ipc: ["ipc"] as const,
  ipcPlanning: (horizon: string) => ["ipc", "planning", horizon] as const,
  ipcMinutes: (project: string) => ["ipc", "minutes", project] as const,
};
